import React, { ReactNode, useEffect, useState } from "react";
import Modal from "common/Modal/Modal";
import ExclamationCircleOutlined from "@ant-design/icons/ExclamationCircleOutlined";
import { LanguageNameSpaces, OpenConfirmModal } from "@shared/types";
import { HookAPI } from "antd/es/modal/useModal";
import { isArray } from "lodash";
import Text from "common/Typography/Text";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation.ts";

interface useConfirmModalProps {
  loading?: boolean;
  title?: string;
  confirmModal?: HookAPI;
  modalWidth?: number;
}

const useConfirmModal = ({
  title,
  loading,
  confirmModal: propsConfirmModal,
  modalWidth,
}: useConfirmModalProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.COMMON);
  const [confirmModalInstance, setConfirmModalInstance] = useState<any>();
  const [isDanger, setIsDanger] = useState<boolean | undefined>();
  const [confirmModal, confirmModalContextHolder] = Modal.useModal();

  const getModalContent = (confirmStr: ReactNode | string[]) => {
    if (isArray(confirmStr)) {
      return (
        <div style={{ rowGap: 12, display: "grid" }}>
          {confirmStr.map((row, index) => (
            <Text key={index}>{row}</Text>
          ))}
        </div>
      );
    }
    return confirmStr;
  };

  const openConfirmModal: OpenConfirmModal = (
    confirmStr,
    handleOk,
    isDangerParam,
    hideCancel,
    okText,
    cancelText
  ) => {
    setIsDanger(isDangerParam);
    setConfirmModalInstance(
      (propsConfirmModal || confirmModal).confirm({
        title: title || t("labels.confirm"),
        content: getModalContent(confirmStr),
        icon: <ExclamationCircleOutlined />,
        okText: okText || t("labels.yes"),
        okButtonProps: { danger: isDangerParam },
        cancelText: cancelText || t("labels.no"),
        onOk: handleOk,
        width: modalWidth,
        cancelButtonProps: hideCancel
          ? { style: { display: "none" } }
          : undefined,
      })
    );
  };

  useEffect(() => {
    confirmModalInstance?.update({
      okButtonProps: { loading: loading, danger: isDanger },
    });
  }, [loading, confirmModalInstance, isDanger]);

  return { confirmModal, confirmModalContextHolder, openConfirmModal };
};

export default useConfirmModal;
